import React, { memo, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col } from 'antd';
import { translate } from '@components/i18n';
import { Table } from '@components/table';
import { SorterResult, FilterValue } from 'antd/lib/table/interface';
import { ModalContext } from 'src/contexts/modal-context';
import { columns } from '../constants';
import { EditModal } from './edit-modal';
import { fetchRoute, routeSelector } from '@redux/slices/route';
import { RouteResponse } from '@models/route';

export const Body: React.FC = memo(() => {
    const dispatch = useDispatch();
    const itemData = useSelector(routeSelector);
    const modalContext = useContext(ModalContext);

    const edit = (
        data: RouteResponse,
        _: number,
        event: React.MouseEvent<HTMLElement, MouseEvent>,
    ): void => {
        if (
            !`${event.target}`.includes('SVG') &&
            !`${event.target}`.includes('Button') &&
            !`${event.target}`.includes('Span')
        )
            modalContext.setIsOpen(
                true,
                <EditModal
                    data={data}
                    key={`editing-item-${data.codigoCompanhia}`}
                />,
                {
                    title: `${translate('general.editItem')} - ${
                        data.codigoCompanhia
                    }`,
                    width: '40%',
                },
            );
    };

    const loadData = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pagination: any,
        _: Record<string, FilterValue>,
        sorter: SorterResult<unknown>,
    ): void => {
        dispatch(
            fetchRoute({
                ...pagination,
                field: sorter.field,
                order: sorter.order,
            }),
        );
    };

    return (
        <Col>
            <Table
                columns={columns}
                rowKey={(record: RouteResponse) => `${record.id}`}
                dataSource={itemData.list}
                pagination={itemData.request}
                pointer
                onRowClick={edit}
                scroll={{ y: 'calc(100vh - 380px)' }}
                onChange={loadData}
                isLoading={itemData.isFetching}
            />
        </Col>
    );
});
